export const FETCH_VIBRATION_AGENT_METADATA_REQUEST = 'FETCH_VIBRATION_AGENT_METADATA_REQUEST';
export const FETCH_VIBRATION_AGENT_METADATA_SUCCESS = 'FETCH_VIBRATION_AGENT_METADATA_SUCCESS';
export const FETCH_VIBRATION_AGENT_METADATA_FAILURE = 'FETCH_VIBRATION_AGENT_METADATA_FAILURE';
